import * as React from "react";
import { forwardRef } from "react";
const SvgHome = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 32, viewBox: "0 -960 960 960", width: 32, ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "white", d: "M160-120v-480l320-240 320 240v480H560v-280H400v280H160Z" }));
const ForwardRef = forwardRef(SvgHome);
export { ForwardRef as ReactComponent };
